import { render, staticRenderFns } from "./info-sidebar.vue?vue&type=template&id=0c1db9ab&scoped=true&"
import script from "./info-sidebar.vue?vue&type=script&lang=js&"
export * from "./info-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./info-sidebar.vue?vue&type=style&index=0&id=0c1db9ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1db9ab",
  null
  
)

export default component.exports